module.exports = __webpack_public_path__ + "static/media/logo_se.2b3bb0d3.svg";